<template>
  <el-dialog
    :visible="true"
    width="700px"
    :before-close="handleClose"
    :title="title"
  >
    <el-form>

          <el-form-item
            label="Képviselő"
            v-if="!this.$route.params.id"
          >
            <el-select
              v-model="representative"
              style="width: 100%;"
              filterable
              value-key="id"
              @change="onUserChange"
            >
              <el-option
                v-for="user in users"
                :key="user.id"
                :label="`${user.last_name} ${user.first_name}`"
                :value="user"
              />
            </el-select>
          </el-form-item>


      <div class="" v-if="representative">

        <el-divider content-position="left">PÁROS HÉT</el-divider>

        <el-collapse v-model="activeNames">
          <el-row v-for="(day, dayIndex) in tourRules.even">
            <el-collapse-item :title="day.label + ' - ' + day.shops.length + ' db'" :name="day.label + 'even'">
              <el-col>
                <div class="" style="margin: 10px;">
                  <div
                    v-for="(shop, index) in day.shops"
                    :key="`${index}-routeitem`"
                  >
                    <el-row>
                      <el-col>
                        <shop-card :shop="day.shops[index]" :index="index" :shops="shops" :day-index="dayIndex" @remove="removeShop('even', dayIndex, index)" @select="selectShop('even', dayIndex, index, $event)"/>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-col>
              <el-col>
                <el-button
                  style="margin-bottom: 20px;"
                  type="success"
                  icon="el-icon-plus"
                  size="small"
                  @click="addShop('even', dayIndex)"
                >
                  Új bolt
                </el-button>
              </el-col>
            </el-collapse-item>
          </el-row>
        </el-collapse>


        <el-divider content-position="left">PÁRATLAN HÉT</el-divider>

        <el-collapse v-model="activeNames">
          <el-row v-for="(day, dayIndex) in tourRules.odd">
            <el-collapse-item :title="day.label + ' - ' + day.shops.length + ' db'" :name="day.label + 'odd'">
              <el-col>
                <div class="" style="margin: 10px;">
                  <div
                    v-for="(shop, index) in day.shops"
                    :key="`${index}-routeitem`"
                  >
                    <el-row>
                      <el-col>
                        <shop-card :shop="day.shops[index]" :index="index" :shops="shops" :day-index="dayIndex" @remove="removeShop('odd', dayIndex, index)" @select="selectShop('odd', dayIndex, index, $event)"/>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-col>
              <el-col>
                <el-button
                  style="margin-bottom: 20px;"
                  type="success"
                  icon="el-icon-plus"
                  size="small"
                  @click="addShop('odd', dayIndex)"
                >
                  Új bolt
                </el-button>
              </el-col>
            </el-collapse-item>
          </el-row>
        </el-collapse>
      </div>

      </el-form>


    <div
      slot="footer"
      class="dialog-footer"
    >
      <div>
        <el-button @click="handleClose">
          Mégse
        </el-button>
        <el-button
          type="primary"
          @click="store"
        >
          Mentés
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>

  import ShopCard from "./components/ShopCard";

  export default {
    components: {ShopCard},
    data() {
      return {
        users: [],
        activeNames: [],
        representative: null,
        shops: [],
        tourRules: {
          even: [
            {
              label: 'Hétfő',
              shops: [],
            },
            {
              label: 'Kedd',
              shops: [],
            },
            {
              label: 'Szerda',
              shops: [],
            },
            {
              label: 'Csütörtök',
              shops: [],
            },
            {
              label: 'Péntek',
              shops: [],
            },
            {
              label: 'Szombat',
              shops: [],
            },
            {
              label: 'Vasárnap',
              shops: [],
            },
          ],
          odd: [
            {
              label: 'Hétfő',
              shops: [],
            },
            {
              label: 'Kedd',
              shops: [],
            },
            {
              label: 'Szerda',
              shops: [],
            },
            {
              label: 'Csütörtök',
              shops: [],
            },
            {
              label: 'Péntek',
              shops: [],
            },
            {
              label: 'Szombat',
              shops: [],
            },
            {
              label: 'Vasárnap',
              shops: [],
            },
          ],
        },

      };
    },
    computed: {
      title() {
        if (this.$route.params.id && this.representative) {
          return `${this.representative.last_name} ${this.representative.first_name} túra szabályának szerkesztése`
        } else {
          return 'Túra szabály létrehozása'
        }
      }
    },
    async mounted() {
      this.users = await axios.get('api/tour-calendar-rules/representatives');

      if (this.$route.params.id) {
        let response = await axios.get('api/tour-calendar-rules/' + this.$route.params.id);
        this.representative = response.representative;
        this.tourRules = response.data;
        this.shops = await axios.get('api/tour-calendar-rules/representatives/' + this.representative.id + '/shops');
      }
    },
    methods: {
      async onUserChange() {
        this.shops = await axios.get('api/tour-calendar-rules/representatives/' + this.representative.id + '/shops');
      },

      addShop(type, dayIndex) {
        this.tourRules[type][dayIndex].shops.push(null)
      },

      removeShop(type, dayIndex, index) {
        this.tourRules[type][dayIndex].shops.splice(index, 1)
      },

      selectShop(type, dayIndex, index, e) {
        this.$set(this.tourRules[type][dayIndex].shops, index, e);
      },

      async store() {
        if (this.$route.params.id) {
          await axios.put('api/tour-calendar-rules/' + this.$route.params.id, {
            data: this.tourRules,
          });
        } else {
          await axios.post('api/tour-calendar-rules', {
            user_id: this.representative.id,
            data: this.tourRules,
          });
        }

        this.$emit('update');
        this.$router.replace('/representative-processes/tour-calendar-rules');
      },

      handleClose() {
        this.$confirm('Biztosan elveted a módosításokat?', {
          confirmButtonText: 'Igen',
          type: 'warning',
        })
          .then(() => {
            this.$router.replace('/representative-processes/tour-calendar-rules');
          })
          .catch(() => {
          });
      },
    }
  };
</script>
